import { render, staticRenderFns } from "./AllBalances.vue?vue&type=template&id=7fdecf33&scoped=true&"
import script from "./AllBalances.vue?vue&type=script&lang=js&"
export * from "./AllBalances.vue?vue&type=script&lang=js&"
import style0 from "./AllBalances.vue?vue&type=style&index=0&id=7fdecf33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdecf33",
  null
  
)

export default component.exports